import React from 'react';
import {
  AppBar as MuiAppBar,
  Toolbar,
  Typography,
  Box,
  Button,
  IconButton,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import AddIcon from '@mui/icons-material/Add';
import UserProfileMenu from './UserProfileMenu';

const AppBar = ({
  pathPosition,
  searchComponent,
  onCreateCustomer,
  onCreateProject,
  onCreateTicket,
  onCreateKnowledgeBase,
  onCreateTask,
}) => {
  const { t } = useTranslation();

  return (
    <MuiAppBar position="static" color="transparent" elevation={0}>
      <Toolbar>
        <Box sx={{ flexGrow: 1 }}>{pathPosition}</Box>
        <Box sx={{ flexGrow: 1, marginRight: 3 }}>{searchComponent}</Box>
        <Box
          sx={{ display: 'flex', gap: 2, marginRight: 1, alignItems: 'center' }}
        >
          {onCreateCustomer && (
            <Button
              variant="contained"
              startIcon={<AddIcon />}
              onClick={onCreateCustomer}
              size="small"
            >
              {t('customers.createCustomer')}
            </Button>
          )}
          {onCreateProject && (
            <Button
              variant="contained"
              startIcon={<AddIcon />}
              onClick={onCreateProject}
              size="small"
            >
              {t('projects.createProject')}
            </Button>
          )}
          {onCreateTicket && (
            <Button
              variant="contained"
              startIcon={<AddIcon />}
              onClick={onCreateTicket}
              size="small"
            >
              {t('tickets.createTicket')}
            </Button>
          )}
          {onCreateKnowledgeBase && (
            <Button
              variant="contained"
              startIcon={<AddIcon />}
              onClick={onCreateKnowledgeBase}
              size="small"
            >
              {t('knowledgeBase.createNew')}
            </Button>
          )}
          {onCreateTask && (
            <Button
              variant="contained"
              startIcon={<AddIcon />}
              onClick={onCreateTask}
              size="small"
            >
              {t('tasks.createTask')}
            </Button>
          )}
          <UserProfileMenu />
        </Box>
      </Toolbar>
    </MuiAppBar>
  );
};

export default AppBar;
